import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, IconButton, Stack, Typography } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import CloudIcon from '@mui/icons-material/Cloud';
import { getDefaultAlertProps } from '../../utils/utils';
import { MyAlert } from '../UI/MyAlert';
import { IAlertProps } from '../../interface/IAlertProps';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import { IApiResult } from '../../interface/IApiResult';
import {
  API_STATUS_PROBLEM,
  LECTION_NAME,
  SECTION_NAME,
} from '../../constant/constants';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { WorkspaceDto } from '../../dto/WorkspaceDto';
import { WorkspaceDivItem } from './WorkspaceDivItem';
import { LECTION_ROUTE } from '../../constant/routes';
import { apiGetAllPage } from '../../service/apiGetAllPage';
import { apiAddPage } from '../../service/apiAddPage';
import { apiGetCloudSection } from '../../service/apiGetCloudSection';
import { CloudDto } from '../../dto/CloudDto';
import { DialogGetFromCloud } from '../dialog/DialogGetFromCloud';

export const WorkspaceDiv = () => {
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [openDialogCloudEdit, setOpneDialogCloudEdit] = useState(false);
  const [backDrop, setBackDrop] = useState(false);
  const [pageDtos, setPageDtos] = useState<WorkspaceDto[]>([]);
  const [cloudDtos, setClodDtos] = useState<CloudDto[]>([]);
  const { section, route } = useParams();
  const getPage = async (isClean?: boolean) => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiGetAllPage(
      section ?? '',
      route ?? ''
    );
    if (apiResult.isSuccess) {
      if (isClean) {
        setPageDtos([]);
      }
      setPageDtos(apiResult.data);
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const getCloudSection = async () => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiGetCloudSection(route ?? '');
    if (apiResult.isSuccess) {
      setClodDtos(apiResult.data);
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const handleView = () => {
    window.open(`${LECTION_ROUTE}/${section}/${route}`);
  };

  const addPage = async () => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiAddPage(
      section ?? '',
      route ?? '',
      `${pageDtos.length + 1}`
    );
    if (apiResult.isSuccess) {
      getPage();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const handleUpdate = async () => {
    await getPage();
    await getCloudSection();
  };

  const openEditCloudDialog = () => {
    setOpneDialogCloudEdit(true);
  };

  useEffect(() => {
    getPage();
    getCloudSection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      <BackDropDiv open={backDrop} />
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
      <Stack width="100%" height="100%" padding="10px" alignItems="center">
        <Stack width="90%" height="100%">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '30px',
                color: '#000000',
                letterSpacing: 1,
              }}
              component="text"
            >
              {`${localStorage.getItem(SECTION_NAME)} - ${localStorage.getItem(
                LECTION_NAME
              )}`}
            </Typography>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton size="large" onClick={() => openEditCloudDialog()}>
                  <CloudIcon fontSize="large" sx={{ color: '#2196f3' }} />
                </IconButton>
                <IconButton size="large" onClick={() => addPage()}>
                  <AddCircleOutlineIcon
                    fontSize="large"
                    sx={{
                      color: '#2196f3',
                    }}
                  />
                </IconButton>
              </Stack>
              <Stack padding="5px">
                <IconButton size="large" onClick={handleView}>
                  <ViewInArIcon
                    fontSize="large"
                    sx={{
                      color: '#2196f3',
                    }}
                  />
                </IconButton>
              </Stack>
            </Stack>
          </Stack>
          <Stack marginBottom="20px">
            <div> </div>
          </Stack>
          <Grid container spacing={1}>
            {pageDtos.map((item) => (
              <Grid item xs={12}>
                <WorkspaceDivItem
                  key={item.id}
                  workspaceDto={item}
                  cloudDto={cloudDtos}
                  onUpdate={handleUpdate}
                />
              </Grid>
            ))}
          </Grid>
        </Stack>
      </Stack>
      <DialogGetFromCloud
        idPage=""
        open={openDialogCloudEdit}
        titleCloud=""
        isEdit
        onSave={() => undefined}
        onClose={() => setOpneDialogCloudEdit(false)}
      />
    </Stack>
  );
};
